import { AlertMessage, AlertType, PaginationNavigation, SortTableContext, SpinnerWrapper } from "soprasteria-ui-library";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import * as React from "react";
import { useHistory } from "react-router";
import { IPaginatedResponse } from "../../../api/ApiClient";
import { ListingsApi } from '../../../api/ListingsApi';
import { useAuth } from '../../../App';
import { setMessage } from "../../../helpers/MessageHelper";
import { IListingSearchParams, IPatientsListing } from "../../../models/IPatientsListings";
import { LISTED_PATIENTS } from "../../../utils/RouteConstants";
import { PatientListingSearch } from "./PatientListingSearch";
import { PatientsListingsTable } from './PatientsListingsTable';

export const PatientsListings: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new ListingsApi(auth);

    const [tableData, setTableData] = React.useState<IPatientsListing[]>();
    const [isTableLoading, setIsTableLoading] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();

    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const [searchParams, setSearchParams] = React.useState<IListingSearchParams>({ pageNumber: 1, pageSize: 20 });
    const { sortOrder, selectedPropertyToSortBy, setSortOrder, setSelectedPropertyToSortBy } = React.useContext(SortTableContext);
    const history = useHistory();
    const pageSize = 20;
    const [isFirstSearch, setIsFirstSearch] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (!isFirstSearch) {
            onSortOrderClick();
        }
    }, [selectedPropertyToSortBy, sortOrder])

    const getPatientListings = (searchParams: IListingSearchParams) => {
        setIsTableLoading(true);
        setErrorMessage("");
        if (setSelectedPropertyToSortBy && setSortOrder) {
            if (isFirstSearch) {
                setSelectedPropertyToSortBy(searchParams.propertyToOrderBy);
                if (searchParams?.sortOrder) {
                    setSortOrder(searchParams.sortOrder);
                }
            }
            else {
                setIsFirstSearch(true);
                setSelectedPropertyToSortBy(undefined);
            }
        }
        searchParams.pageSize = pageSize;
        searchParams.pageNumber = searchParams.pageNumber ?? 1;
        history.push(LISTED_PATIENTS, searchParams);

        api.getListedPatients(searchParams, (response: IPaginatedResponse<IPatientsListing[]>) => {
            setTableData(response.data);
            setPaginationHeader(response.paginationHeader);
        }, (message) => {
            const newMessage = setMessage(message, errorMessage ?? "");
            setErrorMessage(newMessage);
            setTableData(undefined);
        }, () => {
            setIsTableLoading(false);
        });

        setSearchParams(searchParams);
        setIsFirstSearch(false);
    }

    const handleClickedPage = (page: number) => {
        if (searchParams) {
            setIsTableLoading(true);
            var currentSearchParams = searchParams;
            currentSearchParams.pageNumber = page;
            history.push(LISTED_PATIENTS, currentSearchParams);

            api.getListedPatients(currentSearchParams, (response) => {
                setTableData(response.data);
                setPaginationHeader(response.paginationHeader);
            }, undefined, () => setIsTableLoading(false));
        }
    }

    const onSortOrderClick = () => {
        if (searchParams && searchParams.careProviderId) {
            setIsTableLoading(true);
            var currentSearchParams = searchParams;
            currentSearchParams.pageNumber = 1;
            currentSearchParams.sortOrder = sortOrder;
            currentSearchParams.propertyToOrderBy = selectedPropertyToSortBy;
            history.push(LISTED_PATIENTS, currentSearchParams);

            api.getListedPatients(currentSearchParams, (response) => {
                setTableData(response.data);
                setPaginationHeader(response.paginationHeader);
            }, undefined, () => setIsTableLoading(false));
        }
    }

    return (
        <SpinnerWrapper isLoading={isTableLoading}>
            <section className="card">
                <div className="card-header">
                    <h2>Listade patienter</h2>
                </div>
                <div className="card-body">
                    <section>
                        <PatientListingSearch onSearchPatientListings={getPatientListings} selectedSordOrderBy={selectedPropertyToSortBy!} selectedSortOrder={sortOrder} preSetSearchParams={history.location.state !== undefined && history.location.state !== null ? history.location.state as any : undefined} />
                        <AlertMessage duration={3000} alertType={AlertType.danger}>{errorMessage}</AlertMessage>
                        <PatientsListingsTable id="patients-table" data={tableData} />
                        <PaginationNavigation
                            ariaLabel="patients by treatment report pagination selector"
                            pagination={paginationHeader}
                            pageNeighbours={2}
                            selectedPage={page => handleClickedPage(page)}
                            showCount={true} />
                    </section>
                </div>
            </section>
        </SpinnerWrapper>
    );
}
